import Container from "../../../../components/container";
import GreetingMembership from "../../../../models/GreetingMembership";
import { DeleteGreetingMembership, UpdateGreetingMembership } from "./buttons";

export default function GreetingMembershipsTable({
  items,
}: {
  items: GreetingMembership[];
}) {
  return (
    <Container className="">
      <div className="lg:hidden">
        {items?.map((item) => (
          <div key={item.id} className="mb-2 w-full rounded-md bg-white p-4">
            <h2>{item.name}</h2>
            <div className="mt-2 flex items-center gap-2">
              <p>Price:</p>
              <p className="text-sm text-gray-500">{item.price ?? 0} Cloods</p>
            </div>
            <div className="flex items-center gap-2">
              <p>Duration (Months):</p>
              <p className="text-sm text-gray-500">{item.duration ?? "N/A"}</p>
            </div>
            <div className="flex items-center gap-2">
              <p>EGreets:</p>
              <p className="text-sm text-gray-500">{item.eGreets ?? 0}</p>
            </div>
            <div className="flex items-center gap-2">
              <p>Active:</p>
              <p className="text-sm text-gray-500">{item.active ? "Yes" : "No"}</p>
            </div>
            <div className="mt-4 flex items-center justify-center gap-2">
              {item.id ? (
                <>
                  <UpdateGreetingMembership id={item.id} />
                  <DeleteGreetingMembership id={item.id} />
                </>
              ) : null}
            </div>
          </div>
        ))}
      </div>

      <table className="hidden min-w-full text-left text-gray-900 lg:table">
        <thead className="rounded-lg text-left text-sm font-normal">
          <tr>
            <th className="px-6 py-3">Name</th>
            <th className="px-6 py-3">Description</th>
            <th className="px-6 py-3">Price</th>
            <th className="px-6 py-3">Duration (Months)</th>
            <th className="px-6 py-3">EGreets</th>
            <th className="px-6 py-3">Active</th>
            <th className="px-6 py-3">Edit</th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {items.map((item) => (
            <tr key={item.id} className="border-b">
              <td className="whitespace-nowrap px-6 py-3">{item.name}</td>
              <td className="max-w-xs truncate px-6 py-4">{item.description || "N/A"}</td>
              <td className="px-6 py-4">C {item.price ?? 0}</td>
              <td className="px-6 py-4">{item.duration ?? "N/A"}</td>
              <td className="px-6 py-4">{item.eGreets ?? 0}</td>
              <td className="px-6 py-4">{item.active ? "Yes" : "No"}</td>
              <td className="px-6 py-4">
                {item.id ? (
                  <div className="flex items-center justify-start gap-2">
                    <UpdateGreetingMembership id={item.id} />
                    <DeleteGreetingMembership id={item.id} />
                  </div>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Container>
  );
}
